export const showNewlines = (value: string) => value?.replace(/\\n/g, '\n');
